import { render } from "./Usager.vue?vue&type=template&id=0d80dcf0&scoped=true&ts=true"
import script from "./Usager.vue?vue&type=script&lang=ts"
export * from "./Usager.vue?vue&type=script&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./Usager.vue?vue&type=style&index=1&id=0d80dcf0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d80dcf0"]])

export default __exports__